import { Injectable, signal, WritableSignal } from '@angular/core';

import { Enrol } from '@app/models';

@Injectable({
  providedIn: 'root',
})
export class EnrolStoreService {
  readonly enrol: WritableSignal<Enrol>;

  constructor() {
    this.enrol = signal(new Enrol());
    const enrol = localStorage.getItem('enrol');
    if (enrol) this.enrol.set(JSON.parse(enrol));
  }

  setEnrollment(enrol: Enrol) {
    this.enrol.set({ ...enrol }); // New ref guarantees signals, but it's noisy.
    localStorage.setItem('enrol', JSON.stringify(enrol));
  }

  unsetEnrollment() {
    this.enrol.set(new Enrol());
    localStorage.removeItem('enrol');
  }

  update(enrol: Partial<Enrol>) {
    const updated = Object.assign(this.enrol(), enrol);
    this.setEnrollment(updated);
  }
}
